import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import Link from "next/link";
import Image from "next/image";

function ImageCard({
  img,
  title1,
  title2,
  url,
  alt,
  bgcolor,
  optionId,
  locale,
  textAlign,
  title
}) {
  const isSmall = optionId == null;

  const width = useMemo(
    () =>
      isSmall
        ? { xs: "150px", sm: "220px", md: "224px" }
        : { xs: "150px", sm: "220px", md: "282px" },
    [isSmall],
  );

  const height = useMemo(
    () =>
      isSmall
        ? { xs: "150px", sm: "220px", md: "224px" }
        : { xs: "150px", sm: "220px", md: "282px" },
    [isSmall],
  );

  const sizes = isSmall
    ? "(max-width:600px) 150px, (max-width:900px) 220px, 224px"
    : "(max-width:600px) 150px, (max-width:900px) 220px, 282px";

  return (
    <Box
      component={Link}
      href={url}
      // prefetch={false}
      data-aos="fade-up"
      sx={{
        width,
        textDecoration: "none",
      }}
    >
      <Box
        sx={{
          "&:hover .img-pick-img": {
            transform: "scale(1.1)",
          },
        }}
      >
        <Box
          role="img"
          aria-label={alt}
          sx={{
            width,
            height,
            borderRadius: "12px 12px 0px 0px",
            overflow: "hidden",
            backgroundColor: bgcolor,
            position: "relative",
          }}
        >
          <Image
            src={img}
            alt={alt || "product"}
            fill
            sizes={sizes}
            loading="lazy"
            style={{
              objectFit: "cover",
              transform: "scale(1)",
              transition: "transform 1s ease",
            }}
            className="img-pick-img"
          />

          {/* نفس تأثير الـ gradient اللي كنت عامله */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.0))",
              pointerEvents: "none",
            }}
          />
        </Box>

        <Box
          component={title ? "h3" : "div"}
          sx={{
            textAlign: "center",
            p: 2,
            fontWeight: "bold",
            fontSize: { xs: "11px", md: "16px" },
            color: "#404456",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            borderRadius: "0px 0px 12px 12px",
          }}
        >
          {title2}
        </Box>
      </Box>
    </Box>
  );
}

export default memo(ImageCard);
